import React from 'react';

const EventWatermark = ({ status, children }) => {
  if (status !== 'SOLD_OUT' && status !== 'CANCELLED') {
    return children;
  }

  const watermarkText = status === 'SOLD_OUT' ? 'SOLD OUT' : 'CANCELLED';
  const textColor = status === 'SOLD_OUT' ? '#dc2626' : '#6b7280';

  return (
    <div className="relative" style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        {children}
      </div>
      {/* Fancy stamp-style watermark - doesn't affect card styling */}
      <div 
        className="absolute inset-0 pointer-events-none z-10"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        <div 
          className="relative"
          style={{
            transform: 'rotate(-25deg)',
            transformOrigin: 'center'
          }}
        >
          {/* Stamp container with decorative border */}
          <div 
            className="relative"
            style={{
              backgroundColor: status === 'SOLD_OUT' ? '#fef3c7' : '#f3f4f6', // Amber-100 for sold out, gray-100 for cancelled
              border: '2px solid ' + textColor,
              borderRadius: '6px',
              padding: '6px 12px',
              boxShadow: `
                0 4px 12px rgba(0, 0, 0, 0.15),
                0 0 0 2px ${status === 'SOLD_OUT' ? 'rgba(251, 191, 36, 0.3)' : 'rgba(156, 163, 175, 0.3)'} inset,
                0 2px 4px rgba(0, 0, 0, 0.1)
              `,
              position: 'relative',
              backgroundImage: status === 'SOLD_OUT' ? `
                repeating-linear-gradient(
                  45deg,
                  transparent,
                  transparent 8px,
                  rgba(220, 38, 38, 0.05) 8px,
                  rgba(220, 38, 38, 0.05) 10px
                )
              ` : `
                repeating-linear-gradient(
                  45deg,
                  transparent,
                  transparent 8px,
                  rgba(107, 114, 128, 0.05) 8px,
                  rgba(107, 114, 128, 0.05) 10px
                )
              `
            }}
          >
            {/* Main text - more subtle */}
            <span 
              className="relative z-10 text-base md:text-lg font-semibold uppercase tracking-wide block"
              style={{ 
                color: textColor,
                letterSpacing: '0.1em',
                textShadow: '0 1px 2px rgba(255, 255, 255, 0.8)',
                fontWeight: '600'
              }}
            >
              {watermarkText}
            </span>
            
            {/* Decorative lines above and below text */}
            <div 
              className="absolute top-0 left-0 right-0 h-0.5"
              style={{
                backgroundColor: textColor,
                opacity: 0.3
              }}
            />
            <div 
              className="absolute bottom-0 left-0 right-0 h-0.5"
              style={{
                backgroundColor: textColor,
                opacity: 0.3
              }}
            />
          </div>
          
          {/* Additional depth shadow */}
          <div 
            className="absolute inset-0 -z-10"
            style={{
              transform: 'translate(2px, 2px)',
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              filter: 'blur(2px)'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EventWatermark;

